import * as React from 'react';
import { Avatar } from '@cian/ui-kit';
import { useContactAvatarContext } from './internal';

/**
 * Компонент аватарки
 * Размер зависит от контекста использования и не должен изменяться напрямую
 *
 * Люди - круглые аватарки
 * Компании - квадратные
 */
export function ContactAvatar(_ref) {
  var type = _ref.type,
      src = _ref.src;

  var _useContactAvatarCont = useContactAvatarContext(),
      size = _useContactAvatarCont.size,
      highlight = _useContactAvatarCont.highlight;

  return /*#__PURE__*/React.createElement(Avatar, {
    type: type,
    src: src,
    size: size,
    highlight: highlight && 'white_100'
  });
}